import { ITaskStatusLog } from '@sdk/contracts';
import { Avatar, Flex } from 'antd';

type Props = {
  log: ITaskStatusLog;
};

const AVATAR_SIZE = 24;

export const TaskLogItem: React.FC<Props> = ({ log }) => {
  if (!log.changedBy) return <span>-</span>;

  const {
    changedBy: { name, lastName, avatar }
  } = log;

  return (
    <Flex gap={4}>
      <Avatar size={AVATAR_SIZE} src={avatar?.url}>
        {!avatar?.url && `${name[0]}${lastName[0]}`}
      </Avatar>
      <span>{`${name} ${lastName}`}</span>
    </Flex>
  );
};
